import request from 'configuration/request';

export const cashWarrantApi = {
  createCashWarrant: (data) => {
    return request({
      url: '/cash_warrant/create/',
      method: 'POST',
      data,
    });
  },

  sendCashWarrantMessage: (warrantID1C) => {
    return request({
      url: `/cash_warrant/send_message/`,
      method: 'POST',
      data: { warrantID1C },
    });
  },

  getCashWarrantUrl: (id) => {
    return request({
      url: `/cash_warrant/${id}/payment_url/`,
      method: 'GET',
    });
  },

  capturedPayment: (data) => {
    return request({
      url: '/cash_warrant/captured_payment/',
      method: 'POST',
      data,
    });
  },

  getCashWarrants: (rentId) => {
    return request({
      url: `/cash_warrant/list/?actID=${rentId}`,
      method: 'GET',
    });
  },

  getCashBoxes: () => {
    return request({
      url: '/cash_box/list/',
      method: 'GET',
    });
  },
  getCashBoxStock: () => {
    return request({
      url: '/stock/list/',
      method: 'GET',
    });
  },
  getCashBoxOrg: () => {
    return request({
      url: '/organization/list/',
      method: 'GET',
    });
  },
};
